import classNames from 'classnames';
import { Spinner } from './Spinner';
import { useEffect, useState } from 'react';

export const PurpleButton = ({ children, className, error, onClick, showloader = false, ...props }) => {
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (error) {
            setIsLoading(false);
        }
    }, [error]);

    return (
        <button
            className={classNames(className, {
                'w-full mt-4': true,
                'flex items-center justify-center': true,
                'py-4 px-4 rounded-xl border-none': true,
                'bg-gradient-to-l from-[#1a1f58] to-[#500f56] text-white': true,
                'font-semibold text-sm': true,
                'cursor-pointer': true,
            })}
            {...props}
            onClick={event => {
                setIsLoading(true);
                onClick(event);
            }}
        >
            {(showloader && isLoading) ? <Spinner /> : children}
        </button>
    );
}